
import React from 'react'
import usePending from '@apex/lib/hooks/usePending'
import Paragraph from './Paragraph'
import RemoveButton from './RemoveButton'
import TextInput from './TextInput'
import Button from './Button'
import Form from './Form'
import List from './List'
import Box from './Box'

/**
 * Teams component.
 */

export default function Teams({ teams, removing, onAdd, onRemove }) {
  return <List>
    {teams.sort(byName).map((team, i) => {
      const last = i == teams.length - 1
      const id = team.id
      return <List.Item key={id} isLast={last}>
        <Team
          pending={removing && removing.id == id}
          onRemove={e => onRemove(team)}
          {...team} />
      </List.Item>
    })}
    <AddForm onSubmit={onAdd} marginTop={16} />
  </List>
}

/**
 * Team component.
 */

function Team({ id, name, pending, onRemove }) {
  return <React.Fragment>
    <Paragraph>{name}</Paragraph>
    <RemoveButton pending={pending} onClick={onRemove} />
  </React.Fragment>
}

/**
 * AddForm component.
 */

function AddForm({ team, onSubmit, ...props }) {
  const [pending, submit] = usePending(onSubmit)
  return <Form reset onSubmit={submit} {...props}>
    <Box display="grid" gridTemplateColumns="1fr auto" gap={8}>
      <TextInput width="100%" name="name" placeholder="Company Name" required />
      <Button theme="primary" pending={pending}>Add team</Button>
    </Box>
  </Form>
}

/**
 * byName sorts by name.
 */

function byName(a, b) {
  return a.name.localeCompare(b.name)
}